import React from "react";
import { IoBusinessOutline, IoListOutline } from "react-icons/io5";

const ViewModeToggle = ({
    viewMode,
    onViewModeChange,
    isLoading = false
}) => {
    const handleToggle = (mode) => {
        if (isLoading || mode === viewMode) return;
        onViewModeChange(mode);
    };

    return (
        <div className="flex items-center bg-gray-100 rounded-lg p-1 shadow-sm">
            <button
                onClick={() => handleToggle('portfolio')}
                disabled={isLoading}
                className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 rounded-md transition-all duration-200 font-medium text-sm sm:min-w-[100px] justify-center ${viewMode === 'portfolio'
                        ? 'bg-blue-500 text-white shadow-sm'
                        : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                    } ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                aria-pressed={viewMode === 'portfolio'}
                title="View Portfolio Facilities"
            >
                <IoBusinessOutline className="w-4 h-4" />
                <span>Portfolio</span>
            </button>

            <button
                onClick={() => handleToggle('deals')}
                disabled={isLoading}
                className={`flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 rounded-md transition-all duration-200 font-medium text-sm sm:min-w-[100px] justify-center ${viewMode === 'deals'
                        ? 'bg-blue-500 text-white shadow-sm'
                        : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                    } ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                aria-pressed={viewMode === 'deals'}
                title="View Deal Facilities"
            >
                <IoListOutline className="w-4 h-4" />
                <span>Deals</span>
            </button>
        </div>
    );
};

export default ViewModeToggle; 